import API_BASE_URL from '../config/apiBaseUrl';
import { fetchJson } from './authFetch';

const apiCall = (endpoint, options = {}) =>
  fetchJson(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const DashboardService = {
  getExecutiveSummary: async () => {
    const response = await apiCall('/dashboard/executive');
    return response || {};
  },

  getPriceAdjustment: async () => {
    const response = await apiCall('/kpi/price-adjustment');
    return response.data || [];
  },

  getOpportunities: async () => {
    const response = await apiCall('/kpi/opportunities');
    return response.data || [];
  },

  getCompetitorPerformance: async () => {
    const response = await apiCall('/kpi/competitors');
    return response.data || [];
  },

  getMarketCoverage: async (oem = null) => {
    const params = oem ? `?oem=${encodeURIComponent(oem)}` : '';
    const response = await apiCall(`/kpi/market-coverage${params}`);
    return response.data || [];
  },

  getCompetitorActivity: async (days = 30) => {
    const response = await apiCall(`/market-watch/competitor-activity?days=${days}`);
    return response.data || [];
  },

  getMissingStockLibelles: async (seller = null) => {
    const params = seller ? `?seller=${encodeURIComponent(seller)}` : '';
    const response = await apiCall(`/ebay/sales/missing-stock-libelles${params}`);
    return response.data || [];
  },

  getDismantlingPriority: async (limit = 20) => {
    const response = await apiCall(`/kpi/dismantling-priority?limit=${limit}`);
    return response.data || [];
  },

  getVhuGuidance: async () => {
    const response = await apiCall('/kpi/vhu-guidance');
    return response;
  },

  getOemDetails: async (oem) => {
    const response = await apiCall(`/oem/${oem}/details`);
    return response.data || [];
  },

  getPriceAdjustmentByPriority: async (priority = 'HIGH') => {
    const response = await apiCall(`/kpi/price-adjustment?priority=${priority}`);
    return response.data || [];
  },
};
